import type { AccountProps } from 'app-components/flux/accounts/accountsTypes';
import type { InstitutionLogin } from 'app-components/flux/institution-logins/institutionLoginsTypes';
import type { Institution } from 'app-components/flux/institutions/institutionsTypes';
import { List, type RecordOf } from 'immutable';

export const APPLE_WALLET_CHANNEL_TYPE = 'APPLE_WALLET';

export function isAppleWalletAccount(account?: RecordOf<AccountProps>): boolean {
  const aggregator = List.isList(account?.aggregators) ? account?.aggregators?.first?.() : account?.aggregators?.[0];
  return aggregator?.channel === APPLE_WALLET_CHANNEL_TYPE;
}

export function isAppleCardAccount(account?: RecordOf<AccountProps>): boolean {
  if (!isAppleWalletAccount(account)) return false;
  return account?.type === 'CREDIT' && account?.subType === 'CREDIT_CARD';
}

export function isAppleCashAccount(account?: RecordOf<AccountProps>): boolean {
  if (!isAppleWalletAccount(account)) return false;
  return account?.type === 'BANK' && account?.subType === 'DIGITAL_CASH';
}

export function isAppleWalletInstitution(institution?: Institution | null): boolean {
  return institution?.aggregator === 'APPLE_WALLET';
}

export function isAppleWalletInstitutionLogin(institutionLogin?: InstitutionLogin | null): boolean {
  return institutionLogin?.channel === APPLE_WALLET_CHANNEL_TYPE;
}
